import React from "react";
import { AiOutlinePoweroff } from "react-icons/ai";
import PropTypes from "prop-types";

export default function BActivateButton({ onActivate, btnText }) {
  return (
    <button
      onClick={onActivate}
      className="py-1 px-3 rounded-md shadow-md bg-yellow-600 text-white flex items-center cursor-pointer hover:bg-yellow-500 transition-all focus:shadow-outline focus:outline-none ml-4"
      type="submit"
    >
      <AiOutlinePoweroff className="mr-1" />
      {btnText}
    </button>
  );
}

BActivateButton.propTypes = {
  onDelete: PropTypes.func.isRequired,
  btnText: PropTypes.string,
};
